import React from "react";

const CheckBoxTick = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_11_6741)">
        <rect
          x="1"
          y="1"
          width="18"
          height="18"
          rx="3"
          fill="#0068FF"
          stroke="#0068FF"
          strokeWidth="2"
        />
        <path
          d="M17.4998 5.83333L7.49984 15.8333L2.9165 11.25L4.0915 10.075L7.49984 13.475L16.3248 4.65833L17.4998 5.83333Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_11_6741">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CheckBoxTick;
